import { render, staticRenderFns } from "./DataCalendarioA.vue?vue&type=template&id=46a6a9f0"
import script from "./DataCalendarioA.vue?vue&type=script&lang=js"
export * from "./DataCalendarioA.vue?vue&type=script&lang=js"
import style0 from "./DataCalendarioA.vue?vue&type=style&index=0&id=46a6a9f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports